export type OptionalExtraQuantity = {
  optionalExtra?: { [keys: string]: number }
}

export enum SchedulableTypeEnum {
  Activity = 'Activity',
  Rental = 'Rental',
  Accommodation = 'Accommodation'
}
